import clsx from 'clsx';
import React from 'react';
import { ButtonProps, PrimaryButton } from '../Base';

type Color = 'grey' | 'blue';

type Props = ButtonProps & { loading?: boolean; color?: Color };

const ColorClassName: Record<Color, string> = {
  grey: 'bg-[#6B7280]',
  blue: 'bg-primary',
};

const Button: React.FC<Props> = ({
  children,
  loading,
  color = 'blue',
  className,
  ...props
}) => (
  <PrimaryButton
    {...props}
    className={clsx(
      'h-6 px-4 py-2 text-base font-normal leading-6 text-white',
      ColorClassName[color],
      className,
    )}
  >
    {loading ? 'Loading...' : children}
  </PrimaryButton>
);

Button.displayName = 'Button';

export default Button;
